// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + "1c8d6b97748d33389b7c" + ".js";
};